export const SET_IMAGE = "CANVAS_SET_IMAGE";  
export const SET_FORMAT = "CANVAS_SET_FORMAT"; 
export const SET_DIMENSION = "CANVAS_SET_DIMENSION"; 
export const SET_POSITION = "CANVAS_SET_POSITION"; 
export const SET_AVIABLE = "CANVAS_SET_AVIABLE";
export const SET_IS_CHANGED = "CANVAS_SET_IS_CHANGED"
export const SET_ROTATED = "CANVAS_SET_ROTATED"
